<template>
  <div
    v-if="promotionData"
    :class="$style['promotion']"
    :style="{
      'grid-row': `${promotionData.row}`
    }"
    @click="onClick">
    <slot name="backgroundVideo" />
    <div :class="$style['promotion__inner']">
      <img :class="$style['promotion__image']" src="/images/promotions/wedding-guests/wedding-guests-text-v2.svg?url">
      <btn
        v-if="promotionData.link && shouldShow(promotionData.link)"
        :class="$style['promotion__btn']"
        aria-label="Go to promotion"
        icon-only="System/arrow-right-s-line"
        color="cta"
        shape="round" />
    </div>
  </div>
</template>
<script>
import baseScript from './Shared/script'

export default {
  extends: baseScript,
  mounted () {
    this.content = ['DEFAULT']
  }
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  background-image: url('/images/promotions/wedding-guests/wedding-guests-v2.webp');
  background-size: cover;

  &__btn {
    top: 4%
  }

  &__image {
    width: 46%;
    height: auto;
    transform: rotate(2.5deg);
    position: absolute;
    left: 4%;
    bottom: 12%;
  }
}
</style>
